// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3YtHc","alert":"SettungsInbox_alert__zgMxT"};